import React, { useContext, useEffect, useReducer, useState } from "react";
import styles from "./Step.module.css";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import PropertyAddress from "../../../assets/componentAssets/properttyAddress.png";
import info from "../../../assets/componentAssets/info.svg";
import defaultImage from "../../../assets/componentAssets/defaultImage.svg";
import { FormHelperText, InputAdornment, TextField } from "@mui/material";
import { reducer } from "../consumptionReducer";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import { formStep6 } from "../../../Utility/utils";
import { form6State } from "../InitialState/form6State";
import BuildingData from "../../../Components/BuildingData/BuildingData";
import UpdatedFile from "../../../Components/Greenox/UpdatedFile/UpdatedFile";
import NavButton from "./NavButton";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import {
  DeleteApi,
  PatchApi,
  base_url,
  getApi,
} from "../../../Utility/network";
import DownloadIcon from "@mui/icons-material/Download";
import UploadImage from "../../../Components/UploadImage/UploadImage";
import axios from "axios";
import uploadIm from "../../../assets/componentAssets/upload.svg";
import deleteicon from "../../../assets/componentAssets/deleteIcon.png";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
function Step6() {
  const {
    state: contextState,
    setState,
    HandleErrorPop,
  } = useContext(AppContext);
  const { language, needLanguage } = contextState;
  const [image, setImage] = useState();
  const [image1, setImage1] = useState();
  const [errorsData, setErrorsData] = useState({});
  const [buildingImg, setBuildingImg] = useState([]);
  const [response, setResponse] = useState(false);
  const [infoText, setInfoText] = useState([]);
  const [pop, setPop] = useState(false);
  const [disableNext, setDisableNext] = useState(true);
  const downLoadImg = async (image) => {
    try {
      const response = await fetch(image, { mode: "cors" });
      if (!response.ok) throw new Error("Failed to fetch image.");

      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = image.split("/").pop() || "downloaded-image";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading image:", error.message);
    }
  };

  const style = { width: "100%" };
  useEffect(() => {
    setTimeout(() => {
      setDisableNext(false);
    }, 3000);
  });
  const handleSubmit = async (num, type) => {
    try {
      if (type === "next") {
        const data = buildingImg?.map((item) => item?.type);

        if (!data.includes(3)) {
          setErrorsData({ building: needLanguage.image_error });
          return;
        }
        try {
          // setState((prev) => ({ ...prev, page: prev.page + 1 }));
          const postEnergy = await getApi(
            `energy_need/${contextState.needId}/calculate_energy_consumption/`
          );
          const generate_pdf = await getApi(
            `records/energy_need/${postEnergy?.data?.data?.id}/generate_energy_need_certificate/`
          );
          if (generate_pdf.status === 200 || generate_pdf.status === 201) {
            setState((prev) => ({
              ...prev,
              needPdfId: postEnergy?.data?.data?.id,
              needPage: 7,
              needFilledPage:
                prev.needFilledPage >= 7 ? prev.needFilledPage : 7,
            }));
          }
        } catch (error) {
          alert(error);
        }
      } else if (type === "prev") {
        setState((prev) => ({ ...prev, needPage: prev.needPage - 1 }));
      } else if (type === "save") {
        await getApi(`/energy_need/${contextState.needId}/generate_link/`);
        // navigate("/login");
        setResponse(true);
      }
    } catch (error) {
      HandleErrorPop(true);
    }
  };

  useEffect(() => {
    if (image) {
      uploadImageApi(3, image);
    }
  }, [image]);

  useEffect(() => {
    if (image1) {
      uploadImageApi(1, image1);
    }
  }, [image1]);
  useEffect(() => {
    getData();
    window.scroll(0, 0);
  }, []);

  const uploadImageApi = (_type, _image) => {
    const formData = new FormData();
    formData.append("image", _image);
    formData.append("type", _type);

    const axiosConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    axios
      .patch(
        `${base_url}/energy_need/${contextState.needId}/upload_building_photos/`,
        formData,
        axiosConfig
      )
      .then((response) => {
        setImage();
        getData();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getData = async () => {
    try {
      const response = await getApi(`/energy_need/${contextState.needId}/`);
      setBuildingImg(response.data.data.building_images);
    } catch (error) {}
  };
  const handleDeleteImg = (id) => {
    DeleteImages(id);
  };
  const DeleteImages = async (id) => {
    try {
      const response = await DeleteApi(`energy_need/building/${id}/`);
      getData();
    } catch (error) {}
  };
  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  const popData = {
    building: [
      {
        heading: needLanguage.build_photo,
        para1: needLanguage.build_photo_info,
      },
    ],
    heater: [
      {
        heading: needLanguage.heater_photo,
        para1: needLanguage.heater_photo_info1,
        para2: needLanguage.heater_photo_info2,
        para3: needLanguage.heater_photo_info3,
        para4: needLanguage.heater_photo_info4,
      },
    ],
  };
  return (
    <div>
      <div className={styles.con}>
        <StepsHeader
          image={uploadIm}
          heading={needLanguage.file_upload}
          secPara={needLanguage.provided_information}
        />
        <div className={styles.fieldDetails}>
          <div
            style={{
              background: "#AFDB2840",
              marginTop: "15px",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            <p className={styles.fieldName}>{needLanguage.title_file_upload}</p>
            <p>
              {needLanguage.heater_photo_info1}{" "}
              {needLanguage.heater_photo_info2}{" "}
              {needLanguage.heater_photo_info3}{" "}
              {needLanguage.heater_photo_info4}
            </p>
          </div>
          <div></div>
          <div>
            <p>
              {/* <b>{needLanguage.photo_heater} </b> */}
              <b className={styles.fieldName}>
                {needLanguage.photo_heater}{" "}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.heater)}
                />{" "}
              </b>
            </p>
            <UploadImage getImage={setImage} imgs={image} />
            <div style={{ marginTop: "20px" }}>
              {buildingImg.map((item) => {
                const filename = item.image.split("/").pop();
                if (item.type !== 3) return;

                return (
                  <div
                    style={{
                      background: "#AFDB2826",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    className={styles.imageContainer}
                  >
                    <div>
                      <div>
                        <img
                          src={item.image}
                          style={{ marginRight: "15px", width: "80px" }}
                        />
                      </div>
                      <div>{filename}</div>
                    </div>

                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        onClick={() => downLoadImg(item.image)}
                        style={{ paddingTop: "10px" }}
                      >
                        <DownloadIcon />
                      </div>
                      <img
                        src={deleteicon}
                        onClick={() => {
                          handleDeleteImg(item?.id);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            {errorsData?.building && (
              <FormHelperText error={errorsData.building}>
                {errorsData?.building}
              </FormHelperText>
            )}
          </div>
        </div>
        <div className={styles.fieldDetails}>
          <div>
            <p>
              <b className={styles.fieldName}>
                {needLanguage.photo_building}{" "}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.building)}
                />{" "}
              </b>
            </p>
            <UploadImage getImage={setImage1} imgs={image1} />
            <div style={{ marginTop: "20px" }}>
              {buildingImg.map((item) => {
                const filename = item.image.split("/").pop();
                if (item.type !== 1) return;
                return (
                  <div
                    style={{
                      background: "#AFDB2826",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    className={styles.imageContainer}
                  >
                    <div>
                      <div>
                        <img
                          src={item.image}
                          style={{ marginRight: "15px", width: "80px" }}
                        />
                      </div>
                      <div>{filename}</div>
                    </div>

                    <div
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        onClick={() => downLoadImg(item.image)}
                        style={{ paddingTop: "10px" }}
                      >
                        <DownloadIcon />
                      </div>
                      <img
                        src={deleteicon}
                        onClick={() => {
                          handleDeleteImg(item?.id);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        response={response}
        disabled={disableNext}
      />
      {pop && (
        <PopUpInfo
          handleClose={() => setPop(false)}
          open={pop}
          data={infoText}
        />
      )}
    </div>
  );
}

export default Step6;
const address = {
  number: [
    {
      heading: "Street Or House Number",
      para1:
        " Please enter the address of the building for which the energy certificate is to be created.",
      para2:
        " You can enter the billing and delivery address in the next step.",
    },
  ],
  Postcode: [
    {
      heading: "Postcode",
      para1:
        " Please enter the address of the building for which the energy certificate is to be created.",
      para2:
        " You can enter the billing and delivery address in the next step.",
    },
  ],
  Location: [
    {
      heading: "Location",
      para1:
        " Please enter the address of the building for which the energy certificate is to be created.",
      para2:
        " You can enter the billing and delivery address in the next step.",
    },
  ],
};
